// extracted by mini-css-extract-plugin
export default {"mainContainer":"sliderTitle_mainContainer__qKAqJ"};